module.exports = "<div ng-if=\"vm.visible\" class=\"save-dialog\">\n  <button ng-click=\"vm.save();\" type=\"button\" name=\"button\" class=\"save\">Speichern</button>\n  <button ng-click=\"vm.cancel();\" type=\"button\" name=\"button\" class=\"cancel\">Abbrechen</button>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/common/saveDialog/saveDialog.html
// module id = 509
// module chunks = 0